import { colors } from 'plume-ui'
import { css } from '@emotion/react'
import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'

type ConditionCircleWrapperProps = {
  children: React.ReactNode
}

export const ConditionCircleWrapper: React.FC<ConditionCircleWrapperProps> = (
  props
) => {
  return (
    <div
      css={css`
        cursor: pointer;
        display: inline-block;
        position: relative;
        vertical-align: middle;
      `}
    >
      {props.children}
    </div>
  )
}

export const ConditionIcon: React.FC = () => {
  return (
    <IcomoonIcon
      name="plus"
      css={css`
        color: ${colors.cyan50};
        font-size: 20px;
      `}
    />
  )
}

type ConditionCircleProps = {
  children: React.ReactNode
  onClick?: () => void
}

export const ConditionCircle: React.FC<ConditionCircleProps> = (props) => {
  return (
    <div
      css={css`
        box-sizing: border-box;
        background-color: #ffffff;
        border: 2px solid ${colors.cyan50};
        border-radius: 50%;
        padding: 8px 8.5px 8px 9px;
        width: 42px;
        height: 42px;
        line-height: 1;
        transition: 0.15s;
        :hover {
          background-color: ${colors.cyan50};
          border: 2px solid ${colors.cyan50};
          /* あまり良くないselectorだが、この要素自体の利用scopeを狭めたい */
          * {
            transition: 0.15s;
            color: #fff;
          }
        }
      `}
    >
      {props.children}
    </div>
  )
}
